import { EmptyState } from '@codex/ui';
import { createFileRoute } from '@tanstack/react-router';
import { MISSING } from '../../views/ViewPage.js';

/** The bare `/views`: there is no page listing every view; a view is opened from its type. */
export const Route = createFileRoute('/views/')({ component: NoView });

function NoView(): React.JSX.Element {
  return (
    <main className="cx-catalogue">
      <EmptyState title={MISSING} headingLevel={2}>
        <a href="/">Go home</a>
      </EmptyState>
    </main>
  );
}
